export const BRLFormat = (value: number) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

export const ptBRFormat = (value: number) => {
  return new Intl.NumberFormat("pt-BR").format(value);
};

export const moneyFormat = (value: number | undefined, currency: string) => {
  if (value === null || value === undefined) {
    return `${new Intl.NumberFormat(currency === "BRL" ? "pt-BR" : "en-US", {
      style: "currency",
      currency: currency,
    }).format(0)}`.replace(/0[,.]00$/, "-");
  }

  return new Intl.NumberFormat(currency === "BRL" ? "pt-BR" : "en-US", {
    style: "currency",
    currency: currency,
  }).format(value);
};
